module.exports = __webpack_public_path__ + "static/fonts/Simple-Line-Icons.0cb0b9c.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module id = 886
// module chunks = 3